import React from 'react';
import Animation from './Animation';

/**
 *
 * @param {Boolean} deleteTrigger - when true, delete sequence will begin
 * @param {Function} onDelete - a callback to be called when delete sequence ended
 *
 */
const Deleteable = ({
  deleteTrigger = false,
  onDelete = () => {},
  children,
  ...animationProps
}) => {
  return (
    <Animation
      in={!deleteTrigger}
      onExited={onDelete}
      type="collapse"
      {...animationProps}
    >
      {children}
    </Animation>
  );
};

export default Deleteable;
